import React from "react";

export default function PromocionesSumary({ stats = [], filtro, aplicarFiltro }) {
  return (
    <div className="management-card mb-4">
      <div className="promociones-summary-grid">
        {stats.map((stat) => {
          const isActive =
            stat.filter &&
            filtro?.tipo === stat.filter.tipo &&
            filtro?.valor === stat.filter.valor;
          const accentClass = stat.accent ? `accent-${stat.accent}` : "";
          return (
            <div key={stat.label} className="w-100">
              <div
                className={`management-stat-card promociones-summary-card h-100 d-flex align-items-center gap-3 ${accentClass} ${isActive ? "active" : ""}`}
                role="button"
                tabIndex={0}
                onClick={() =>
                  stat.filter
                    ? aplicarFiltro(stat.filter.tipo, stat.filter.valor)
                    : aplicarFiltro("all")
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    stat.filter
                      ? aplicarFiltro(stat.filter.tipo, stat.filter.valor)
                      : aplicarFiltro("all");
                  }
                }}
              >
                <div className="management-stat-icon">
                  <i className={stat.icon} />
                </div>
                <div>
                  <p className="management-stat-label mb-1">{stat.label}</p>
                  <div className="management-stat-value">{stat.value}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
